export const wrapperClassname = "w-64 box-content"
